import { render, staticRenderFns } from "./PageModuleModal.vue?vue&type=template&id=00d03c59&scoped=true&"
import script from "./PageModuleModal.vue?vue&type=script&lang=js&"
export * from "./PageModuleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d03c59",
  null
  
)

export default component.exports